const points = [
  {
    title: 'Gehostet in Deutschland',
    body: 'Gateway auf STACKIT, GPU-Hardware in neXenio-Hoheit. Kein US-Cloud-Anbieter im Pfad, kein ngrok, kein Drittland-Transfer.',
  },
  {
    title: 'Verschlüsselt in Transit',
    body: 'TLS-Terminierung am EU-Edge via Let’s Encrypt. Backend-Strecken zu GPU-Servern über WireGuard.',
  },
  {
    title: 'DSGVO & BSI-fest',
    body: 'API-Schlüssel pro Kunde, strukturierte JSON-Audit-Logs, opt-in Datenhaltung. Entworfen gegen BSI-C5-Kontrollen und EU-AI-Act-Pflichten.',
  },
  {
    title: 'Auditierbar, ersetzbar',
    body: 'Offene Standards entlang des Stacks — Caddy, Docker, WireGuard, Postgres. Jede Schicht (inkl. Hoster) ist tauschbar, ohne neu zu bauen.',
  },
];

export default function Trust() {
  return (
    <section id="sovereign" className="border-b border-rule bg-bg-elev/30">
      <div className="mx-auto max-w-[1280px] px-6 py-20 md:px-10 md:py-28">
        <div className="grid gap-16 md:grid-cols-12">
          <div className="md:col-span-5">
            <p className="label-mono mb-6 text-accent">— 03 / Souveränität</p>
            <h2 className="text-3xl font-bold uppercase tracking-[-0.01em] text-ink md:text-4xl">
              Daten bleiben hier<span className="text-accent">.</span>
            </h2>
            <p className="mt-6 max-w-md text-fg-muted">
              Souveränität ist eine Eigenschaft der ganzen Pipeline, kein Häkchen im Datenblatt. So
              bauen wir sie ein.
            </p>

            <SovereignDiagram />
          </div>

          <dl className="grid gap-x-10 gap-y-10 md:col-span-7 md:grid-cols-2">
            {points.map((p) => (
              <div key={p.title} className="border-l border-accent pl-5">
                <dt className="font-mono text-[11px] font-semibold uppercase tracking-[0.14em] text-accent">
                  {p.title}
                </dt>
                <dd className="mt-3 text-sm leading-relaxed text-fg-muted">{p.body}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}

function SovereignDiagram() {
  // 12 stars on a circle — EU flag motif. Static (Trust section), inner orbit packets implied by dashed ring.
  const stars = Array.from({ length: 12 }, (_, i) => {
    const a = (i / 12) * Math.PI * 2 - Math.PI / 2;
    return { x: 110 + Math.cos(a) * 78, y: 110 + Math.sin(a) * 78 };
  });
  return (
    <svg viewBox="0 0 220 220" aria-hidden className="mt-10 w-56 opacity-90">
      <circle
        cx="110"
        cy="110"
        r="58"
        fill="none"
        stroke="#FF7A45"
        strokeOpacity="0.4"
        strokeDasharray="3 4"
      />
      <circle cx="110" cy="110" r="6" fill="#FF7A45" />
      <g fill="#FF7A45">
        {stars.map((s, i) => (
          <Star key={i} cx={s.x} cy={s.y} />
        ))}
      </g>
    </svg>
  );
}

function Star({ cx, cy }: { cx: number; cy: number }) {
  // 5-point star, small
  const r1 = 5;
  const r2 = 2.2;
  const pts: string[] = [];
  for (let i = 0; i < 10; i++) {
    const r = i % 2 === 0 ? r1 : r2;
    const a = (i / 10) * Math.PI * 2 - Math.PI / 2;
    pts.push(`${cx + Math.cos(a) * r},${cy + Math.sin(a) * r}`);
  }
  return <polygon points={pts.join(' ')} />;
}
